import SubmissionError from '../../../error/SubmissionError';
import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  CURRENCYTYPE_UPDATE_RESET,
  CURRENCYTYPE_UPDATE_UPDATE_ERROR,
  CURRENCYTYPE_UPDATE_UPDATE_LOADING,
  CURRENCYTYPE_UPDATE_UPDATE_SUCCESS,
  CURRENCYTYPE_UPDATE_RETRIEVE_ERROR,
  CURRENCYTYPE_UPDATE_RETRIEVE_LOADING,
  CURRENCYTYPE_UPDATE_RETRIEVE_SUCCESS,
  CURRENCYTYPE_UPDATE_UPDATE_VIOLATIONS
} from './mutation-types';

const state = {
  loading: false,
  retrieveError: '',
  retrieveLoading: false,
  retrieved: null,
  updated: null,
  updateError: '',
  updateLoading: false,
  violations: null
};

function retrieveError(retrieveError) {
  return {type: CURRENCYTYPE_UPDATE_RETRIEVE_ERROR, retrieveError};
}

function retrieveLoading(retrieveLoading) {
  return {type: CURRENCYTYPE_UPDATE_RETRIEVE_LOADING, retrieveLoading};
}

function retrieveSuccess(retrieved) {
  return {type: CURRENCYTYPE_UPDATE_RETRIEVE_SUCCESS, retrieved};
}

function updateError(updateError) {
  return {type: CURRENCYTYPE_UPDATE_UPDATE_ERROR, updateError};
}

function updateLoading(updateLoading) {
  return {type: CURRENCYTYPE_UPDATE_UPDATE_LOADING, updateLoading};
}

function updateSuccess(updated) {
  return {type: CURRENCYTYPE_UPDATE_UPDATE_SUCCESS, updated};
}

function violations(violations) {
  return {type: CURRENCYTYPE_UPDATE_UPDATE_VIOLATIONS, violations};
}

function reset() {
  return {type: CURRENCYTYPE_UPDATE_RESET};
}

const getters = {
  loading: state => state.loading,
  retrieveError: state => state.retrieveError,
  retrieveLoading: state => state.retrieveLoading,
  retrieved: state => state.retrieved,
  updated: state => state.updated,
  updateError: state => state.updateError,
  updateLoading: state => state.updateLoading,
  violations: state => state.violations
};

const actions = {
  retrieve({ commit }, id) {
    commit(retrieveLoading(true));
    commit(retrieveError(null));
   return http.fetch('/currency_types/' + id)
      .then(response => response.json())
      .then(data => {
        commit(retrieveLoading(false));
        commit(retrieveSuccess(data));
      })
      .catch(e => {
        commit(retrieveLoading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(retrieveError(e.message));
      });
  },
  update({ commit, state }, { item, values }) {
    commit(updateError(null));
    commit(violations({}));
    commit(updateLoading(true));

   return http.fetch(item['@id'] , {
        method: 'PUT',
        headers: new Headers({'Content-Type': 'application/ld+json'}),
        body: JSON.stringify(values),
      }
    )
      .then(response => response.json())
      .then(data => {
        commit(updateLoading(false));
        commit(updateSuccess(data));
      })
      .catch(e => {
        commit(updateLoading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors));
          return;
        }

        commit(updateError(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [CURRENCYTYPE_UPDATE_RETRIEVE_ERROR] (state, payload) {
      state.retrieveError = payload.retrieveError;
    },
    [CURRENCYTYPE_UPDATE_RETRIEVE_LOADING] (state, payload) {
      state.retrieveLoading = payload.retrieveLoading;
    },
    [CURRENCYTYPE_UPDATE_RETRIEVE_SUCCESS] (state, payload) {
      state.retrieved = payload.retrieved;
    },
    [CURRENCYTYPE_UPDATE_UPDATE_LOADING] (state, payload) {
      state.updateLoading = payload.loading;
    },
    [CURRENCYTYPE_UPDATE_UPDATE_ERROR] (state, payload) {
      state.updateError = payload.updateError;
    },
    [CURRENCYTYPE_UPDATE_UPDATE_SUCCESS] (state, payload) {
      state.updated = payload.updated;
      state.violations = null;
    },
    [CURRENCYTYPE_UPDATE_UPDATE_VIOLATIONS] (state, payload) {
      state.violations = payload.violations;
    },
    [CURRENCYTYPE_UPDATE_RESET] (state) {
      state.loading = false;
      state.retrieveError = '';
      state.retrieveLoading = false;
      state.retrieved = null;
      state.updated = null;
      state.updateError = '';
      state.updateLoading = false;
      state.violations = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/currencytype/update.js